import React, { useRef } from 'react';
import './contact.css';
import {MdOutlineMail} from 'react-icons/md';
import {BsMessenger, BsWhatsapp} from 'react-icons/bs';
import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_plpdnuk', 'template_am2iiqd', form.current, 'Td2n1sVRbHEk6wyFa')
      .then((result) => {
          //console.log(result.text);
          e.target.reset();
      }, (error) => {
          //console.log(error.text);
          e.target.reset();
      });
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
       <div className="contact__options">
        <article className="contact__option">
         <MdOutlineMail className='contact__option-icon'/>
         <h4>Email</h4>
         <h5>tariq.kharsa@gmail.com</h5>
         <a href="mailto:tariq.kharsa@gmail.com" target="_blank" rel="noreferrer">Send an email</a>
        </article>
        <article className="contact__option">
         <BsMessenger className='contact__option-icon'/>
         <h4>Messenger</h4>
         <h5>Tariq Kharsa</h5>
         <a href="https://m.me/tariq.kharsa" target="_blank" rel="noreferrer">Send a message</a>
        </article>
        <article className="contact__option">
         <BsWhatsapp className='contact__option-icon'/>
         <h4>Whatsapp</h4>
         <h5>+1 (832)-503-0173</h5>
         <a href="https://api.whatsapp.com/send?phone=+18325030173" target="_blank" rel="noreferrer">Send a text</a>
        </article>
       </div>
       <form ref={form} onSubmit={sendEmail}>
        <input type="text" name='name' placeholder='Your Full Name' required />
        <input type="email" name='email' placeholder='Your Email' required />
        <textarea name='message' rows="7" placeholder='Your Message' required></textarea>
        <button type="submit" className='btn btn-primary'>Send Message</button>
       </form>
      </div>
    </section>
  )
}

export default Contact